import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { CommunitiesEndpoints } from 'src/client/constants'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { jwt } from 'src/utils'
import { CommunityGroupsResponse } from 'src/client/types'
import { useUser } from '../useUser'
import { UseCommunityGroupsProps } from './useCommunityGroupsByMembership.types'
import { COMMUNITIES_ROWS } from './useCommunityGroupsByMembership.constants'

const useCommunityGroupsByMembership = ({ membershipSlug }: UseCommunityGroupsProps) => {
  const { authStatus, user } = useUser()

  const isAuthenticated = Boolean(
    authStatus === AuthStatus.AUTHENTICATED && !jwt.isExpired(user?.token)
  )
  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED
  const enabled = Boolean(membershipSlug) && (isAuthenticated || isUnauthenticated)
  const url = isUnauthenticated
    ? CommunitiesEndpoints.getCommunityGroupsPublic(membershipSlug)
    : CommunitiesEndpoints.getCommunityGroups(membershipSlug)

  return useHotRequest<CommunityGroupsResponse>(url, {
    cacheKey: [url],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_COMMUNITY_GATEWAY,
    params: {
      rows: COMMUNITIES_ROWS
    },
    queryOptions: {
      enabled,
      ...DEFAULT_CACHE_CONFIG
    }
  })
}

export default useCommunityGroupsByMembership
